/**
 * Fonte comum dos widgets de solicitações internas (W1 e W3): o mesmo
 * `/api/solicitacoes/pendencias-resumo` do sino, com a promessa reaproveitada
 * por 30 s — dois widgets na tela não fazem duas chamadas.
 */
import { obterPendenciasSolicitacoes } from "../../../services/solicitacoes";

const VALIDADE_MS = 30000;
let cache = null;

export function pendenciasSolicitacoes(request) {
  const agora = Date.now();
  if (cache && agora - cache.em < VALIDADE_MS) return cache.promessa;
  const promessa = obterPendenciasSolicitacoes(request).catch((e) => {
    cache = null; // falhou: a próxima tentativa busca de novo
    throw e;
  });
  cache = { em: agora, promessa };
  return promessa;
}

const TIPOS = ["asm", "ast", "asp", "rqa", "rqi"];

/** Tem a ação em algum tipo (código global ou por tipo)? */
export function temAcaoEmAlgumTipo(hasAllPermissions, acao, tipos = TIPOS) {
  if (hasAllPermissions([`solicitacao:${acao}`])) return true;
  return tipos.some((t) => hasAllPermissions([`solicitacao_${t}:${acao}`]));
}
